export const REQUIRED_SCORE = 2000;
export const CONTRACT_ADDRESS = "0xEf704F492E8945099E316e4745135800aaAa9133";
